module.exports = __webpack_public_path__ + "img/gy.6a64d2f4.svg";